<d-card class="login">
  <img class="logo" src="https://ciam-cdnendpoint.azureedge.net/testasset01/login.png" alt="Spark" />
  <form [formGroup]="usernameForm" (ngSubmit)="signIn()">
    <div>
      <input
        class="input"
        type="text"
        formControlName="username"
        placeholder="Email address"
        autocomplete="off"
      />
      <ng-container *ngIf="isValidInput">
        <div class="msg_error">Please enter a valid email address.</div>
      </ng-container>
      <div *ngIf="isrisk" class="msg_error">
        Cannot use this email address. Try with alternate email address
      </div>
    </div>
    <!-- <div><a [routerLink]="['/recovery/password']">Forgotten password?</a></div> -->
    <div class="footer-card to_right">
      <d-button
        [type]="'submit'"
        [buttonClasses]="buttonStatus"
        (click)="signIn()"
        >Next</d-button
      >
    </div>
  </form>
</d-card>
